module.exports = __webpack_public_path__ + "img/score_header.c0d48f3d.png";